import { bind } from '@react-rxjs/core';
import { createSignal } from '@react-rxjs/utils';
import { distinctUntilChanged, map, merge } from 'rxjs';
import { pathname$ } from '../../services/browserHistory';

export const [setSettingsSidebar$, setSettingsSidebar] =
  createSignal<boolean>();
export const [useSettingsSidebarOpen] = bind(
  merge(
    setSettingsSidebar$,
    pathname$.pipe(
      distinctUntilChanged(),
      map(() => false)
    )
  ),
  false
);
